// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SelectionCardContract = contract({
  name: "SelectionCard",
  description: "A selectable option where the WHOLE card is the control — plan pickers, shipping/payment options, onboarding choices, settings toggles. Use RadioCard for single-select (inside a RadioGroup), CheckboxCard for multi-select, SwitchCard for an on/off option. The glyph differs by type on purpose so single-select vs multi-select vs toggle reads at a glance. All three share one `.gds-selection-card` surface so they look identical sitting together, and every visual is token-driven (`--gds-selection-card-*` with semantic fallbacks) so a project can re-skin them through the per-project override layer without forking.",
  import: "@gradeui/ui",
  aliases: ["selection card","radio card","checkbox card","switch card","option card","choice card","plan picker","pricing option","selectable card","tile select"],
  subcomponents: ["RadioCard","CheckboxCard","SwitchCard"],
  composesWith: ["RadioGroup","Badge","Label","Grid","Stack"],
  styleDefaults: {"RadioCard":"gds-selection-card","CheckboxCard":"gds-selection-card","SwitchCard":"gds-selection-card"},
  props: {
  "label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "title line. Omit and pass `children` for fully custom content.",
  },
  "description": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "secondary line under the label.",
  },
  "aside": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "slot between content and indicator (a Badge, price, kbd hint).",
  },
  "hideIndicator": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the dot/check/switch glyph; selection is then shown by the card's selected border + background. Semantics stay intact.",
  },
  "indicatorPosition": {
      schema: z.enum(["leading", "trailing"]).optional(),
      design: "knob",
      description: "which side the glyph sits on; default trailing.",
  },
  "value": {
      schema: z.enum(["string"]).optional(),
      design: "knob",
      description: "required; sits inside a `RadioGroup`. Renders as a RadioGroupPrimitive.Item.",
  },
  "checked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "renders as a CheckboxPrimitive.Root.",
  },
  "defaultChecked": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "renders as a CheckboxPrimitive.Root.",
  },
  "onCheckedChange": {
      schema: z.unknown().optional(),
      design: "event",
      description: "renders as a CheckboxPrimitive.Root.",
  },
  },
});
